/* @flow */

export const normalizeName = (name: string) => {
  if (typeof name !== 'string') {
    name = name.toString()
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

export const normalizeValue = (value: any) => {
  if (typeof value !== 'string') {
    value = value.toString()
  }
  return value
}

class Headers {
  map: Object

  constructor(headers: Headers | Object) {
    this.map = {}
    if (headers instanceof Headers) {
      headers.forEach((name: string, values: Array<string>) => {
        values.forEach((value: string) => {
          this.append(name, value)
        })
      })
    } else if (typeof headers === 'object') {
      Object.getOwnPropertyNames(headers).forEach((name) => {
        // $FlowFixMe: flow trips over headers[name]
        this.append(name, headers[name])
      })
    }
  }

  append(name: string, value: string) {
    name = normalizeName(name)
    value = normalizeValue(value)
    let list = this.map[name]
    if (!list) {
      list = []
      this.map[name] = list
    }
    list.push(value)
  }

  delete(name: string) {
    delete this.map[normalizeName(name)]
  }

  get(name: string) {
    const values = this.map[normalizeName(name)]
    return values ? values[0] : null
  }

  getAll(name: string) {
    return this.map[normalizeName(name)] || []
  }

  has(name: string) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  set(name: string, value: string) {
    this.map[normalizeName(name)] = [normalizeValue(value)]
  }

  forEach(callback: (string, Array<string>) => void) {
    Object.getOwnPropertyNames(this.map).forEach((name) => {
      callback(name, this.map[name])
    })
  }
}
export default Headers
